module.exports = __webpack_public_path__ + "static/media/imagesets.4729f92b.jpg";